import { useSite } from '../../context/SiteContext';

export const useActiveSiteApptLength = () => {
  const { activeSite } = useSite();

  return activeSite?.appt_length;
};
